class StepsSlider {
  constructor(element) {
    this.slider = element;
    this.track = this.slider.querySelector('.steps-slider__track');
    this.slides = this.slider.querySelectorAll('.steps-slider__slide');
    this.prevButton = this.slider.querySelector('.steps-slider__arrow--prev');
    this.nextButton = this.slider.querySelector('.steps-slider__arrow--next');
    this.indicators = this.slider.querySelectorAll('.steps-slider__indicator');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    
    this.autoplay = this.slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.slider.dataset.autoplaySpeed || '5') * 1000;
    this.autoplayTimer = null;
    
    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;
    
    this.bindEvents();
    this.updateSlider();
    
    if (this.autoplay) {
      this.startAutoplay();
    }
    
    // Pause autoplay on hover
    this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
    this.slider.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }
    
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(index);
      });
    });
    
    // Touch/swipe support
    let startX = 0;
    let endX = 0;
    
    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });
    
    this.slider.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      this.handleSwipe(startX, endX);
    });
    
    // Keyboard navigation
    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
      }
    });
  }

  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateSlider();
    this.resetAutoplay();
  }

  prevSlide() {
    this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
    this.updateSlider();
    this.resetAutoplay();
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlider();
    this.resetAutoplay();
  }

  updateSlider() {
    if (!this.track) return;
    
    const translateX = -this.currentSlide * 100;
    this.track.style.transform = `translateX(${translateX}%)`;
    
    // Update indicators
    this.indicators.forEach((indicator, index) => {
      indicator.classList.toggle('steps-slider__indicator--active', index === this.currentSlide);
    });
  }

  startAutoplay() {
    if (!this.autoplay || this.totalSlides <= 1) return;
    
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {
    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
}

// Initialize all sliders
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.steps-slider');
  sliders.forEach(slider => new StepsSlider(slider));
});

// Reinitialize on theme editor changes
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const sliders = document.querySelectorAll('.steps-slider');
    sliders.forEach(slider => new StepsSlider(slider));
  });
}
